import { getDefaultThresholdFromConfig } from '@/features/settings/utils/resolveDashboardSetting';

export interface ComplianceSummaryBadgesProps {
  compliantAB: boolean;
  className?: string;
  minimumPercent?: number;
}

export function ComplianceSummaryBadges({
  compliantAB,
  className = '',
  minimumPercent = getDefaultThresholdFromConfig('Budget Law A+B Minimum Percent'),
}: ComplianceSummaryBadgesProps) {
  return (
    <div className={className}>
      <span
        className={`inline-flex items-center rounded-md px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide ring-1 print:text-[8px] ${
          compliantAB
            ? 'bg-emerald-100 text-emerald-900 ring-emerald-200'
            : 'bg-red-100 text-red-800 ring-red-200'
        }`}
      >
        {compliantAB
          ? `Compliant (A+B ≥ ${minimumPercent}%)`
          : `Non-compliant (A+B < ${minimumPercent}%)`}
      </span>
    </div>
  );
}
